import VueQuillEditor from "vue-quill-editor";
import Quill from "quill";
import ImageCompress from "quill-image-compress";

Quill.register("modules/imageCompress", ImageCompress);

const toolbarOptions = {
  container: [
    [{ header: [1, 2, 3, false] }],
    ["bold", "italic", "underline"],
    [{ list: "ordered" }, { list: "bullet" }, { align: [] }],
    // [{ color: [] }, { background: [] }],
    ["link", "image"],
    ["clean"],
    ["emoji"],
  ],
  handlers: { emoji: function () {} },
};
export default {
  install(Vue) {
    Vue.use(VueQuillEditor, {
      modules: {
        // ...
        toolbar: toolbarOptions,
        imageCompress: {
          quality: 0.7, // default
          maxWidth: 300, // default
          maxHeight: 300, // default
        },
        "emoji-toolbar": true,
        "emoji-shortname": true,
      },
    });
  },
};
